import SortDescIcon from 'remixicon-react/SortDescIcon'

import {DropdownSelect} from '@festi/common/components/form'

import useAlgoliaSearch from '../utilites/useAlgoliaSearch'

const sortOptions = [
  {label: 'Vinsælt', value: 'popular'},
  {label: 'Mest selt', value: 'sold'},
  {label: 'Ódýrast efst', value: 'price_asc'},
  {label: 'Dýrast efst', value: 'price_desc'},
  {label: 'Nýjast efst', value: 'new'},
]

interface Props {
  iconOnly?: boolean
}

export default function SortDropdown({iconOnly}: Props) {
  const {queryParams, setSorting} = useAlgoliaSearch()

  return (
    <DropdownSelect
      label="Raða eftir"
      icon={SortDescIcon}
      items={sortOptions}
      iconOnly={iconOnly}
      value={queryParams.sort?.[0] || 'popular'}
      onValueChange={(value) => setSorting(value)}
    />
  )
}
